import React from 'react';
import usePage from '@dashboard/hooks/usePage';
import { Form } from '@dashboard/components/Formik';
import Button from '@dashboard/components/Button';

const DiscountCodeForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Form
      autosave
      showState={false}
      initialValues={{
        showCouponCodeFieldType: page?.showCouponCodeFieldType,
      }}
      fields={[
        {
          name: 'showCouponCodeFieldType',
          label: 'Show as',
          type: 'radio',
          options: [
            {
              label: '"Add discount code" link',
              value: 'link',
            },
            {
              label: 'Discount code field',
              value: 'field',
            },
          ],
        },
        {
          type: 'custom',
          renderField: () => (
            <Button appearance="secondary" size="small" to="/coupons/new">
              Create coupon
            </Button>
          ),
        },
      ]}
      onSubmit={async values => {
        const { data, error } = await updatePage.mutateAsync(values);

        return { data, error };
      }}
    />
  );
};

export default DiscountCodeForm;
